import {Component, inject, input} from '@angular/core';
import {NgClass} from "@angular/common";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {navItems} from "./navItems";
import {CustomTranslateService} from "../../core/service/custom-translate.service";
import {toSignal} from "@angular/core/rxjs-interop";


@Component({
    selector: 'navigation',
    imports: [
        NgClass,
        TranslatePipe
    ],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
    private readonly i18n = inject(CustomTranslateService);

    // Tilanvaihtaja mobiilivalikolle
    menuOpen: boolean = false;

    langMenuOpen: boolean = false;

    protected readonly navItems = navItems;

    protected readonly translateService = inject(TranslateService);

    //input signal
    currentLanguage = this.i18n.current;

    toggleMenu(): void {
        this.menuOpen = !this.menuOpen;
    }


}
